module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00088-fs8.d9bd0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00088-fs8.png
// module id = 241
// module chunks = 0